/**
 * Popup marché : affichage première visite (cookie persistant), scroll lock, dismiss.
 */
(function () {
  const root = document.querySelector('[data-csk-market-popup-root]');
  if (!root) return;

  const cookieName = root.dataset.cookieName || 'csk_market_popup_seen';
  const maxAge = parseInt(root.dataset.cookieMaxAge || '31536000', 10);
  const allowDismiss = root.dataset.allowDismiss === 'true';
  const designMode = root.dataset.designMode === 'true';

  function hasCookie() {
    return document.cookie.split(';').some((c) => c.trim().startsWith(`${cookieName}=`));
  }

  function setCookie() {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${cookieName}=1; path=/; max-age=${maxAge}; SameSite=Lax${secure}`;
  }

  function show() {
    root.hidden = false;
    const y = window.scrollY;
    root.dataset.scrollY = String(y);
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${y}px`;
  }

  function hide() {
    root.hidden = true;
    const y = parseInt(root.dataset.scrollY || '0', 10);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, y);
  }

  function dismiss() {
    setCookie();
    hide();
  }

  /**
   * Mappe un code pays ISO 3166-1 alpha-2 vers le code langue ISO le plus probable.
   * Retourne null si inconnu (on laissera la langue par défaut du store).
   */
  function langForCountry(cc) {
    const map = {
      // Français
      FR: 'fr', BE: 'fr', CH: 'fr', LU: 'fr', MC: 'fr', SN: 'fr',
      CI: 'fr', CM: 'fr', MG: 'fr', ML: 'fr', BF: 'fr', NE: 'fr',
      // Anglais
      US: 'en', GB: 'en', CA: 'en', AU: 'en', NZ: 'en', IE: 'en',
      ZA: 'en', SG: 'en', HK: 'en', NG: 'en', GH: 'en', KE: 'en',
      IN: 'en', PK: 'en', PH: 'en', MY: 'en',
      // Allemand
      DE: 'de', AT: 'de',
      // Espagnol
      ES: 'es', MX: 'es', AR: 'es', CO: 'es', CL: 'es', PE: 'es',
      VE: 'es', EC: 'es', BO: 'es', PY: 'es', UY: 'es', CR: 'es',
      // Portugais
      PT: 'pt', BR: 'pt', AO: 'pt', MZ: 'pt',
      // Néerlandais
      NL: 'nl',
      // Italien
      IT: 'it',
      // Japonais
      JP: 'ja',
      // Coréen
      KR: 'ko',
      // Chinois
      CN: 'zh', TW: 'zh',
      // Hébreu
      IL: 'he',
      // Arabe
      SA: 'ar', AE: 'ar', EG: 'ar', MA: 'ar', DZ: 'ar', TN: 'ar',
      // Russe
      RU: 'ru',
      // Turc
      TR: 'tr',
      // Polonais
      PL: 'pl',
      // Suédois
      SE: 'sv',
      // Norvégien
      NO: 'nb',
      // Danois
      DK: 'da',
      // Finnois
      FI: 'fi',
      // Roumain
      RO: 'ro',
      // Grec
      GR: 'el',
      // Tchèque
      CZ: 'cs',
      // Hindi
      // IN déjà mappé sur 'en' (anglais officiel), on garde 'en'
    };
    return map[cc] || null;
  }

  if (designMode) {
    show();
  } else if (hasCookie()) {
    root.remove();
    return;
  } else {
    // Première visite : aligner la langue sur le pays géolocalisé par Shopify.
    // Si le pays n'est pas mappé ou la langue n'est pas disponible, fallback sur 'fr'.
    const langSelect = root.querySelector('[name="language_code"]');
    if (langSelect) {
      const countrySelect = root.querySelector('[name="country_code"]');
      const countryCode = countrySelect ? countrySelect.value : null;
      const targetLang = countryCode ? langForCountry(countryCode) : null;

      const hasOption = (code) => !!langSelect.querySelector(`option[value="${code}"]`);

      if (targetLang && hasOption(targetLang)) {
        langSelect.value = targetLang;
      } else if (hasOption('fr')) {
        langSelect.value = 'fr';
      }
    }
    show();
  }

  const form = root.querySelector('.csk-market-popup__form');
  if (form) {
    form.addEventListener('submit', () => {
      setCookie();
    });
  }

  if (allowDismiss) {
    const backdrop = root.querySelector('[data-csk-market-popup-backdrop]');
    const btn = root.querySelector('[data-csk-market-popup-dismiss-btn]');
    backdrop?.addEventListener('click', () => dismiss());
    btn?.addEventListener('click', () => dismiss());
  }
})();
